// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8720) return "static/chunks/8720-5f65033c1639b71d.js";
	if (chunkId === 2534) return "static/chunks/2534-73d9b7484b540bea.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"717":"c59475a00699af89","1646":"314724838722bc18","1891":"c8f5e19820af85c3","2482":"a215fba6678c32c9","3757":"10e333356672aaa5","4634":"993dc44efef982c6","5139":"3af505ae0c727fe9","8131":"2ea8d43f29467ced","8352":"c277d6d4b43d29b0","8456":"9e99a5da5b35887f","8572":"495d85bc78c998ed","8870":"2b44db1e2b622880"}[chunkId] + ".js";
};